
import { BadRequestException } from '../services/exceptions';
import { get, post } from './http'

export async function getMeta(props) {
  // console.log('newsApi getMeta props:', props)
  const response = await get(`/numerableNews/meta?days=365`)

  if (response.ok) {
    let json = await response.json()
    return json
  } else
    throw new BadRequestException((await response.json()).message);
}

export async function getRelease(props) {
  // getReleaseExternal(props)
  // console.log('newsApi getRelease props:', props)
  const response = await get(`/numerableNews/release?id=${props.id}`)

  if (response.ok) {
    let json = await response.json()
    return json
  } else
    throw new BadRequestException((await response.json()).message);
}

export async function getReleaseExternal(props) {
  const response = await get(`/news/release?id=${props.id}&key=c4fdda03f6d84f4ea9300ad009f32a14`)
  if (response.ok) {
    let json = await response.json()
    console.clear()
    console.log('json:', json)
  } else
    throw new BadRequestException((await response.json()).message);
}

export async function regenerateSummary(props) {
  // console.log('newsApi regenerateSummary props:', props)
  const response = await post(`/numerableNews/regenerateSummary?id=${props.id}`, {})

  if (response.ok) {
    let json = await response.json()
    return json
  } else
    throw new BadRequestException((await response.json()).message);
}

export async function searchDocument(props) {
  // console.log('searchDocument props:',props)
  const response = await get(`/numerableNews/search?value=${props.searchString}`)
  if (response.ok) {
    let json = await response.json()
    // console.log('json:', json)
    return json
  } else
    throw new BadRequestException((await response.json()).message)
}